const KeenSlider = window.KeenSlider

const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class ProductCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.35,
          spacing: 10,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 3,
              spacing: 10,
            },
          },
          '(min-width: 1201px)': {
            slides: {
              perView: 4,
              spacing: 10,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('product-carousel')) {
  customElements.define('product-carousel', ProductCarousel)
}
